import { StrictMode } from "react";
import { createRoot } from "react-dom/client";

// Inter carries the interface, per the Master Design Contract §3. IBM Plex
// Mono stays for identifiers, backend codes, Evidence timestamps and logs —
// the places where a fixed advance is the point rather than a texture.
import "@fontsource-variable/inter";
import "@fontsource/ibm-plex-mono";

import "@/design-system/tokens.css";

import { App } from "@/app/App";
import { ErrorBoundary } from "@/design-system/ErrorBoundary";

const container = document.getElementById("root");
if (container === null) {
  throw new Error("the root element is missing from index.html");
}

createRoot(container).render(
  <StrictMode>
    <ErrorBoundary>
      <App />
    </ErrorBoundary>
  </StrictMode>,
);
